












































import { defineComponent, reactive, watch, ref } from "@vue/composition-api";
import ShareJourneyViewModel from "@/models/ShareJourneyViewModel";

export default defineComponent({
    name: "ShareDialog",
    props: {
        value: { type: Boolean, default: false },
        model: { type: Object, default: null }
    },
    setup(props, context) {
        const shareModel = reactive<ShareJourneyViewModel>(new ShareJourneyViewModel());
        const shareImageAspectRatio = ref(1);  // Default to 1:1 aspect ratio

        if (props.model) {
            shareModel.headline = props.model.headline || '';
            shareModel.text = props.model.text || '';
            shareModel.imageUrl = props.model.imageUrl || '';
        }

        const share = () => {
            context.emit("input", false);
            context.emit("OnShare");
        };

        const close = () => {
            context.emit("input", false);
            context.emit("OnCancel");
        };

        const shareImage = ref<any>(null);

        const updateAspectRatio = () => {
            const imgElement = shareImage.value.image;

            if (imgElement && imgElement.naturalWidth && imgElement.naturalHeight) {
                shareImageAspectRatio.value = imgElement.naturalWidth / imgElement.naturalHeight;
            } 
        };

        watch(() => props.model, (newModel) => {
            if (newModel) {
                if (newModel.headline) shareModel.headline = newModel.headline;
                if (newModel.text) shareModel.text = newModel.text;
                if (newModel.imageUrl) shareModel.imageUrl = newModel.imageUrl;
            }
        });


        return {
            close,
            shareModel,
            share,
            updateAspectRatio,
            shareImageAspectRatio,
            shareImage
        };
    },
    watch: {
    value(isOpen) {
        if (isOpen) {
            console.log('Share dialog is open');
            // Dialog is being opened, scroll the content to the top of the picture
            this.$nextTick(() => {
                const scrollableContent = this.$el.querySelector('.scrollable-content');
                if (scrollableContent) {
                    console.log('Scrolling to top');
                    scrollableContent.scrollTop = 0;
                }
            });
        }
    },
},
});
